var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "dropdown" } }, [
    _c("div", { staticClass: "dropdown-filter" }, [
      _vm.hasSelection
        ? _c("div", { staticClass: "row no-gutters" }, [
            _vm.filter.categoria
              ? _c(
                  "div",
                  {
                    staticClass: "alink mr-1",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("categoria")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("CATEGORIA")]),
                    _c("b", [_vm._v(_vm._s(_vm.filter.categoria))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filter.durata
              ? _c(
                  "div",
                  {
                    staticClass: "alink mr-1",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("durata")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("DURATA")]),
                    _vm._v(" "),
                    _c("b", { staticClass: "mr-1" }, [
                      _vm._v(_vm._s(_vm.filter.durata[0]))
                    ]),
                    _vm._v("-\n                "),
                    _c("b", [_vm._v(_vm._s(_vm.filter.durata[1]))])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bg-white" }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Categoria")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    "row no-gutters bg-light " +
                    (_vm.isMobile ? "pl-3 py-1" : "pl-5 py-3")
                },
                _vm._l(_vm.categories, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "col-12 col-md-4 pretty p-default p-curve"
                    },
                    [
                      _c("input", {
                        attrs: { type: "radio", name: "categoria" },
                        domProps: { checked: _vm.filter.categoria === item },
                        on: {
                          click: function($event) {
                            return _vm.onSelect("categoria", item)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-secondary-o" }, [
                        _c("label", [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(item) +
                              "\n                                "
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Durata")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    "bg-light " + (_vm.isMobile ? "px-3 py-1" : "px-5 py-3")
                },
                [
                  _c("DurationRangeSlider", {
                    staticStyle: { "max-width": "300px" },
                    attrs: {
                      min: _vm.min,
                      max: _vm.max,
                      value: _vm.filter.durata
                    },
                    on: { input: _vm.onInputDurata }
                  })
                ],
                1
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-030ece3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030ece3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/experience/dropdown/DropdownFilterExperience.vue
// module id = null
// module chunks = 